import React from "react";
import GaugeComponent from "react-gauge-component";

export interface GaugeMeterProps {
	width: string;
	healthScore: number;
}

const GaugeMeter: React.FC<GaugeMeterProps> = ({ healthScore, width }): JSX.Element => {
	return (
		<GaugeComponent
			style={{ width }}
			labels={{
				valueLabel: {
					matchColorWithArc: true,
					style: {
						fontSize: "50px",
						textShadow: "none",
						fontWeight: "600"
					}
				}
			}}
			arc={{
				cornerRadius: 50,
				subArcs: [
					{
						limit: 20,
						color: "#EA4228",
						showTick: true
					},
					{
						limit: 40,
						color: "#F58B19",
						showTick: true
					},
					{
						limit: 60,
						color: "#F5CD19",
						showTick: true
					},
					{
						limit: 100,
						color: "#15D199",
						showTick: true
					}
				]
			}}
			value={healthScore}
		/>
	);
};

export default GaugeMeter;
